import { Label, PrimaryButton, Spinner, SpinnerSize, Stack, Text, TextField } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { popup } from '../../../addons/Popup';
import { history } from '../../../App/history';
import { getAsync } from '../../../utils/api';
import ContentBox from '../../ContentBox';

type MapsData = {
  address?: string;
  city?: string;
  subCity?: string;
  street?: string;
  postalCode?: string;
};

export default ({ setAddress }: { setAddress: React.Dispatch<any> }) => {
  const { formId } = useParams();
  const [mapsData, setMapsData] = useState<MapsData>();

  useEffect(() => {
    getAsync("/invoices/get-maps-data?formId=" + formId)
      .then((body) => {
        console.log(body.data);

        setMapsData(body.data);
      })
      .catch(async (e) => {
        console.error(e);

        await popup(
          "Hata: Form bilgilerinde veya sistemde bir hata meydana geldi"
        );

        setMapsData({});
        history.push("/");
      });
  }, [formId]);

  if (!mapsData) {
    return (
      <Spinner
        style={{ height: "60vh" }}
        label="Yükleniyor"
        size={SpinnerSize.large}
      />
    );
  } else {
    return (
      <div
        id="invoice-form"
        style={{
          width: "40%",
          maxWidth: "600px",
          marginTop: "12px",
        }}
      >
        <Stack tokens={{ childrenGap: 10 }}>
          <Text variant="xxLarge">Fatura Bilgileri</Text>
          <ContentBox>
            <Stack tokens={{ childrenGap: 10 }}>
              <Stack.Item>
                <Label>Forma Yazılan Fatura Adresi</Label>
                {mapsData.address || "-"}
              </Stack.Item>
              <Stack horizontal grow tokens={stackTokens}>
                <Stack.Item grow>
                  <TextField name="buildingName" label="Bina Adı" />
                </Stack.Item>
                <Stack.Item grow>
                  <TextField name="buildingNumber" label="Bina No" />
                </Stack.Item>
                <Stack.Item grow>
                  <TextField name="doorNumber" label="Kapı No" />
                </Stack.Item>
              </Stack>
              <Stack horizontal grow tokens={stackTokens}>
                <Stack.Item grow>
                  <TextField
                    styles={textFieldStyle}
                    name="street"
                    label="Mahalle"
                    defaultValue={mapsData.street}
                  />
                </Stack.Item>
                <Stack.Item grow>
                  <TextField
                    styles={textFieldStyle}
                    name="subCity"
                    label="Semt / İlçe"
                    defaultValue={mapsData.subCity}
                    required
                  />
                </Stack.Item>
                <Stack.Item grow>
                  <TextField
                    name="postalCode"
                    label="Posta Kodu"
                    defaultValue={mapsData.postalCode}
                    required
                  />
                </Stack.Item>
              </Stack>
              <Stack horizontal grow tokens={stackTokens}>
                <TextField
                  styles={textFieldStyle}
                  name="city"
                  label="Şehir"
                  defaultValue={mapsData.city}
                  required
                />
                <TextField
                  styles={textFieldStyle}
                  name="country"
                  label="Ülke"
                  value="Türkiye"
                  required
                  disabled
                />
              </Stack>
              <Stack horizontalAlign="end">
                <PrimaryButton
                  text="Devam"
                  onClick={() => submit(setAddress)}
                />
              </Stack>
            </Stack>
          </ContentBox>
        </Stack>
      </div>
    );
  }
};

const submit = (setAddress: React.Dispatch<any>) => {
  const form = document.querySelector("#invoice-form");
  if (!form) throw "form not found";

  const variables = [
    "buildingName",
    "buildingNumber",
    "doorNumber",
    "postalCode",
    "street",
    "subCity",
    "city",
  ];

  const entries = variables.map((varName) => {
    const input = form.querySelector(`[name="${varName}"]`);

    if (input instanceof HTMLInputElement) {
      return [varName, input.value];
    } else {
      return [varName, null];
    }
  });

  const payload = Object.fromEntries(entries);

  if (!payload.city || !payload.subCity) {
    popup("Fatura bilgileri hatalı");
    return;
  }

  setAddress(payload);
};

const textFieldStyle = { root: { width: "100%" } };
const stackTokens = { childrenGap: 5 };
